import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserService } from '@shared/services/user.service';
import { Platform, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '@shared/utils/util';
import { VoiceRecorder, RecordingData} from 'capacitor-voice-recorder';
import { Directory, Filesystem, } from '@capacitor/filesystem';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MediaService {

  public recording: boolean = false;
  filePath: string | any;
  fileName: string | any;
  public duration: number | any;
  private startRecordingTime: number = (new Date()).getTime();
  public isNative: boolean = true;
  private base64Soung: any;
  private audioRef: any;
  public playbackProgress: number = 0; 
  public currentTimePlayed: number = 0;


  constructor(public http: HttpClient,
    public userService: UserService,
    public util: UtilService,
    private toastCtrl: ToastController,
    private translate: TranslateService,
    public platform: Platform) {
    console.log('Hello MediaServiceProvider Provider');

    platform.ready().then(() => {

      console.log('document.URL: ' + document.URL);
      this.isNative = this.util.isNative();

    });

  }
  ngOnInit() {
    VoiceRecorder.requestAudioRecordingPermission();
  }

  async fileExists(filename: string): Promise<boolean> {

    console.log('filename to check if exists: ' + filename);
    let filePath = this.getFilePathForPlayback();

    console.log('filePath: ' + filePath);

    try {
      await Filesystem.stat({
        path: filePath,
        directory: Directory.Data,
      });

      return true;

    } catch (error) {

      return false;
    }

  }

  public getFilePathForPlayback() {
    let filePath = '';
    if (!this.platform.is('android')) {
      filePath = Directory.Documents;

    } else if (this.platform.is('android')) {
      filePath = Directory.External;
    }
    return filePath;
  }

  public getFilePath() {
    let filePath = '';
    if (!this.platform.is('android')) {
      filePath = Directory.Documents.replace(/file:\/\//g, '');
    } else if (this.platform.is('android')) {
      filePath = Directory.External.replace(/file:\/\//g, '');
    }
    return filePath;
  }

  startRecord() {
    console.log('Will start to startRecord..');
    this.fileName = 'record' + new Date().getDate() + new Date().getMonth() + new Date().getFullYear() + new Date().getHours() + new Date().getMinutes() + new Date().getSeconds() + '.3gp';

    let folder = this.getFilePathForPlayback();
    this.filePath = this.getFilePath() + this.fileName;

    console.log('Will set recording to true..');
    console.log('Will create file: ' + this.filePath);
    console.log('Will create file: ' + this.fileName);

    console.log('Will call startRecord on MediaObject..');
    this.startRecordingTime = (new Date()).getTime();
    VoiceRecorder.startRecording();
    console.log('Will set recording to true..');
    this.recording = true;


    // Filesystem.writeFile({
    //   path: this.fileName, 
    //   directory: Directory.Data,
    //   data: ''
    // }).then((createResult) => {
    //   console.log('startRecord createFile result: ' + JSON.stringify(createResult));

    //   console.log('Will call startRecord on MediaObject..');
    //   this.startRecordingTime = (new Date()).getTime();
    //   VoiceRecorder.startRecording();
    //   console.log('Will set recording to true..');
    //   this.recording = true;
    // }).catch((err) => {
    //   console.log('startRecord createFile error: ' + JSON.stringify(err));
    // });


  }

  async stopRecord(): Promise<any> {
    let fileAudio: any;
    let uri = VoiceRecorder.stopRecording().then(async (result: RecordingData) => {
      if (result.value && result.value.recordDataBase64) {
        const recordData = result.value.recordDataBase64;
        console.log('recordDataBase64: ' + recordData);
        this.fileName = 'record' + new Date().getDate() + new Date().getMonth() + new Date().getFullYear() + new Date().getHours() + new Date().getMinutes() + new Date().getSeconds() + '.3gp';

        fileAudio = await Filesystem.writeFile({
          path: this.fileName,
          directory: Directory.Data,
          data: recordData
        });
        let stopRecordingTime = (new Date()).getTime();
        this.duration = Math.ceil((stopRecordingTime - this.startRecordingTime) / 1000);

        this.recording = false;
        console.log("fileAudio.uri:" + fileAudio.uri)
        return fileAudio.uri
      }
    });

    return uri;
  }

  private messagePlaying: any = null;

  playAudio(aMessage: any) {
    console.log('playAudio aMessage: ' + JSON.stringify(aMessage));
    let fileAudio: any;
    let fileId: any

    try {
      fileAudio = JSON.parse(aMessage.message);
      fileId = fileAudio.fileId
    } catch (error) {
      fileId = aMessage.fileId
      aMessage.isPaused = false;
    }
    console.log(fileAudio)

    this.stopOtherAudio();

    if (aMessage.isPaused) {
      this.audioRef.play();
      aMessage.isPlaying = true;
      aMessage.isPaused = false;
      return;
    }

    const url: string = `${environment.mainServer}/soul/audio/${fileId}`;
    console.log("Audio URL: ", url);

    this.audioRef = new Audio(url);
    this.messagePlaying = aMessage; // Esta é agora a mensagem ativa gerenciada pelo audioRef

    // Listener para atualizações de tempo
    this.audioRef.ontimeupdate = () => {
        if (this.audioRef && this.messagePlaying === aMessage) {
            this.messagePlaying.currentTimePlayed = this.audioRef.currentTime;
            const duration = parseFloat(this.messagePlaying.duration as string);
            if (duration > 0) {
                this.messagePlaying.playbackProgress = (this.audioRef.currentTime / duration) * 100;
            } else {
                this.messagePlaying.playbackProgress = 0;
            }
            // Se a UI não atualizar, pode ser necessário NgZone:
            // this.ngZone.run(() => {});
        }
    };

    // Listener para quando o áudio termina
    this.audioRef.onended = () => {
        if (this.messagePlaying === aMessage) {
            console.log('Audio ended for message:', aMessage.message);
            this.messagePlaying.isPlaying = false;
            this.messagePlaying.isPaused = false;
            const duration = parseFloat(this.messagePlaying.duration as string);
            this.messagePlaying.currentTimePlayed = duration;
            this.messagePlaying.playbackProgress = 0;

            this.clearAudioRefListeners(); // Limpa listeners
        }
    };

    // Listener para quando o áudio pode começar a tocar
    this.audioRef.oncanplay = () => {
        if (this.audioRef && this.messagePlaying === aMessage) {
            console.log('Audio can play for message:', aMessage.message);
            this.audioRef.play().then(() => {
                if (this.messagePlaying === aMessage) {
                    this.messagePlaying.isPlaying = true;
                }
            }).catch((error: Error) => {
                console.error("Error in oncanplay play attempt:", error);
                if (this.messagePlaying === aMessage) {
                    this.messagePlaying.isPlaying = false;
                }
            });
        }
    };

    // Listener para erros ao carregar/tocar o áudio
    this.audioRef.onerror = (event: Event | string) => {
        console.error("Error with audio element. Message:", aMessage.message, "Event:", event);
        if (this.audioRef && this.audioRef.error) {
            console.error("Audio URL:", this.audioRef.currentSrc || url);
            console.error("Error code:", this.audioRef.error.code, "Message:", this.audioRef.error.message);
        }
        if (this.messagePlaying === aMessage) {
            this.messagePlaying.isPlaying = false;
            this.messagePlaying.isPaused = false;
            this.messagePlaying.currentTimePlayed = 0;
            this.messagePlaying.playbackProgress = 0;
            this.clearAudioRefListeners(); // Limpa listeners
        }
    };

    this.audioRef.load(); // Inicia o carregamento

    // Tentativa inicial de play (navegadores modernos podem enfileirar)
    this.audioRef.play().then(() => {
      if (this.messagePlaying === aMessage && this.audioRef?.duration && this.audioRef.duration > 0) {
        this.messagePlaying.isPlaying = true;
      }
    }).catch((error: { message: any; }) => {
        console.warn(`Initial play() for ${aMessage.message} caught error (often autoplay policy): ${error.message}`);
    });
  }

  private clearAudioRefListeners() {
    if (this.audioRef) {
        this.audioRef.ontimeupdate = null;
        this.audioRef.onended = null;
        this.audioRef.oncanplay = null;
        this.audioRef.onerror = null;
    }
  }
  
    pauseAudio(aMessage: any) {
    this.audioRef.pause();
    aMessage.isPlaying = false;
    aMessage.isPaused = true;
  }

  stopOtherAudio() {
    if (this.messagePlaying != null && this.messagePlaying.isPlaying) {
      this.audioRef.pause();
      this.audioRef.remove();
      this.audioRef.currentTime = 0;
      this.messagePlaying.isPlaying = false;
      this.messagePlaying.isPaused = false;
    }
  }

  public deleteLastLocalAudioIfExists() {
  }

}

